import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

export function useGetGlobalHooks() {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  return {
    dispatch,
    formatMessage,
  };
}
